import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

export interface SidenavItem {
  name: string;
  sectionId: string;
}

@Component({
  selector: 'app-sidenav-tree',
  templateUrl: './sidenav-tree.component.html',
  styleUrls: ['./sidenav-tree.component.scss'],
  imports: [CommonModule],
})
export class SidenavTreeComponent {
  @Output() itemClicked = new EventEmitter<void>();

  // Navigation items for scroll-based navigation (matching header)
  navItems: SidenavItem[] = [
    { name: 'Problem', sectionId: 'problem' },
    { name: 'Product', sectionId: 'product' },
    { name: 'Intelligence', sectionId: 'intelligence' },
    { name: 'Different', sectionId: 'different' },
    { name: 'Flywheel', sectionId: 'working' },
    { name: 'Why', sectionId: 'why' },
    { name: 'Founder', sectionId: 'founder' },
  ];

  constructor(private router: Router) {}

  scrollToSection(sectionId: string): void {
    // Navigate to home first if not already there
    if (this.router.url !== '/') {
      this.router.navigate(['/']).then(() => {
        setTimeout(() => {
          this.performScroll(sectionId);
        }, 100);
      });
    } else {
      this.performScroll(sectionId);
    }
    this.itemClicked.emit();
  }

  private performScroll(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  openProductSite(): void {
    window.open('https://naybrs.com', '_blank', 'noopener');
    this.itemClicked.emit();
  }
}
